export default __webpack_public_path__ + "ca854e6d0785ba4b9d715049c0bdbcb3.png";